import { gql } from '@apollo/client';

/**
 * ERP #110 — «Исправить группу (ошибка ввода)»: правка того же договора на
 * месте, НЕ перевод (ни двойника, ни `transferOut`). Имя операции отлично от
 * поля `correctAgreementGroup`, чтобы codegen не склеил типы.
 *
 * Из `agreement` берём только id и номер. Группу НЕ запрашиваем: её ссылка
 * легла бы в кеш неполной (без курса и прочего, что читает карточка
 * студента), запрос карточки стал бы неполным, ушёл бы в сеть с «Загрузкой…»
 * на месте страницы — и размонтировал окно вместе с экраном «готово»
 * (поймано на стенде). Новую группу карточка получает перечитыванием при
 * закрытии окна. `oldTitle`/`newTitle`/
 * `titleChanged` — для экрана «готово»; `titleKeptReason` — почему номер не
 * пересчитан (`SIGNED_DOCUMENT` | `MANUAL_TITLE` | `NAME_TOO_LONG`).
 */
export const correctAgreementGroupActionDocument = gql`
  mutation CorrectAgreementGroupAction(
    $agreementId: ID!
    $groupId: ID!
    $reason: String!
  ) {
    correctAgreementGroup(
      agreementId: $agreementId
      groupId: $groupId
      reason: $reason
    ) {
      success
      customErrors {
        field
        code
        message
      }
      agreement {
        id
        agreementTitle
      }
      oldTitle
      newTitle
      titleChanged
      titleKeptReason
    }
  }
`;

/**
 * ERP #110 — «Отменить зачисление»: удаление ошибочного договора в окне
 * отмены. `studentVisible=false` — у студента не осталось договоров юрлица,
 * и в ERP он больше не виден: уводить в список, а не на карточку.
 */
export const undoEnrollmentActionDocument = gql`
  mutation UndoEnrollmentAction($agreementId: ID!, $reason: String!) {
    undoEnrollment(agreementId: $agreementId, reason: $reason) {
      success
      customErrors {
        field
        code
        message
      }
      studentId
      studentVisible
    }
  }
`;
